export enum CourseAccessTypeEnum {
  fullAccess = 'full_access',
  partialAccess = 'partial_access',
  drippingContent = 'dripping_content',
}
